var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "is-flex is-centered",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/secret-ciec.svg"),
          alt: "password illustration"
        }
      }),
      _c(
        "div",
        { staticClass: "is-flex is-centered" },
        [
          _c("h1", { staticClass: "title is-2 has-text-primary" }, [
            _vm._v("\n      Guardar CIEC\n    ")
          ]),
          _vm._m(0),
          _c(
            "b-field",
            [
              _c("b-input", {
                attrs: {
                  icon: "archive",
                  type: "password",
                  value: _vm.ciec,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  "password-reveal": ""
                },
                on: { input: _vm.onChangeCIEC }
              })
            ],
            1
          ),
          _c(
            "b-field",
            [
              _c(
                "b-button",
                {
                  attrs: {
                    type: "is-primary",
                    "native-type": "submit",
                    disabled: _vm.loading || !_vm.ciec || _vm.ciec.length === 0,
                    loading: _vm.loading
                  }
                },
                [_vm._v("\n        GUARDAR\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "content" }, [
      _vm._v(
        "\n      Puedes agregar tu CIEC para sincronizar tus facturas con el SAT\n      y poder gestionarlas deste tu portal de facturación favorito\n      "
      ),
      _c("span", { staticClass: "has-text-weight-bold has-text-primary" }, [
        _vm._v("FACTURAV")
      ]),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }